import React, { Component } from 'react'
import { Button } from 'hljd'
import { SHOP_PRODUCTS_PATH_A } from '@constant'
import { getProTitle } from '@util'

import style from './style.module.less'

export default class extends Component {
  click = () => {
    window.location = SHOP_PRODUCTS_PATH_A
  }
  render() {
    return (
      <div className={style.wrapper}>
        <img
          src="//qnm.hunliji.com/o_1ds6ul2401tba1fg14q213q61kvv9.png"
          alt="icon"
          width="144"
          height="144"
          style={{ borderRadius: 6 }}
        />
        <div className={style.main}>
          <div>
            <div className={style.title}>专享优惠</div>
            <div className={style.desc}>
              设置有吸引力的专享优惠，可大幅提高用户的联系意愿、到店率、成单率。
            </div>
          </div>
          <div>
            <div className={style.button}>
              <Button type="primary" onClick={this.click}>
                开通<span style={{ marginRight: 10 }}>{getProTitle()}</span>免费使用
              </Button>
              <span className={style.sub}>超值</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
